import IService from '../IService';

export default IService.extend({
  _getUrl: function (providerName) {
    return app.apiUrl('/api/v1/video/social/' + providerName + '/targets');
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  get: function (data) {
    if (
      app.xhrExpected(this.$ajax) &&
      this.LastData.providerName !== data.providerName
    ) {
      this.$ajax.abort();
    }

    const deferred = new $.Deferred();
    this.LastData = data;
    this.$ajax = $.ajax({
      url: this._getUrl(data.providerName),
      error: function (jqXHR) {
        deferred.reject(jqXHR);
      },
      success: function (response) {
        deferred.resolve(response);
      },
    }).always(() => {
      this.$ajax = null;
    });

    return deferred.promise();
  },
});
